module.exports = __webpack_public_path__ + "img/Truppführer_Fm.24bbcca7.svg";